module.exports = __webpack_public_path__ + "static/media/puppyBlog.15bb928a.png";